<template>
  <div>
    <vsmallheader></vsmallheader>
    <div class="baseBox">
      <div style="margin-top:20px;padding-bottom:10px;display:flex;">
        <div style="font-size:14px;color:#888;display:flex;align-items: center">
          <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
          当前位置：
        </div>
        <span @click="retrun" style="cursor: pointer;font-size:14px">调训管理/ {{baseData.baseName}}</span>
      </div>
      <div class="baseIntroduce">
        <!-- 基地简介 -->
        <div>
          <div style="height:45px;line-height:45px; border-bottom:solid 1px rgb(216, 213, 213)">
            <img
              src="../../../assets/train/u783.png"
              alt
              style="vertical-align:middle;height:30px;width:30px;margin-left:32px"
            />
            <span style="font-size:18px;font-weight:700;margin-left:8px;color:#333333">基地简介</span>
          </div>
          <div class="baseIntroduceMetter">{{baseData.baseDes}}</div>
        </div>
        <!-- 基地占用情况 -->
        <div>
          <div style="height:45px;line-height:45px; border-bottom:solid 1px rgb(216, 213, 213)">
            <img
              src="../../../assets/train/u1524.png"
              alt
              style="vertical-align:middle;height:30px;width:30px;margin-left:32px"
            />
            <span style="font-size:18px;font-weight:700;margin-left:8px;color:#333333">基地培训班</span>
          </div>
          <!-- <div class="occupyMouth">
                        <div v-for="(item,index) in occupyMouth" :key="index" :class="{heightlight : occupyMouthindex==index}" @click="mouthArea(index,item)">{{item}}</div>
          </div>-->
          <div class="baseIntroduceoccupyMouth" v-if="listform.length!==0">
            <div
              style="padding:0 10px;border-bottom:solid 1px #f2f2f2;height:100px"
              v-for="(item,index) in listform"
              :key="index"
            >
              <div
                style="font-size:18px;font-weight:700"
                @click="trainclass(item.id)"
                class="baseuseTitle"
              >{{item.title}}</div>
              <div style="display:flex;margin-top:10px">
                <div style="flex:1">培训人数：{{item.peoplenum}}人</div>
                <div style="flex:1">使用部门：{{item.deptname}}</div>
                <div style="flex:1">培训班管理员：{{item.username}}</div>
              </div>
              <div style="display:flex;margin-top:10px">
                <div style="width:300px;display:flex">
                  <div style="width:85px">管理员电话：</div>
                  <div style="width:205px">{{item.phone}}</div>
                </div>
                <div style="flex:6">使用时间：{{item.startime}} ~ {{item.endtime}}</div>
              </div>
            </div>
          </div>
          <div v-if="listform.length==0" style="padding-top: 100px;">
            <nodata></nodata>
          </div>
          <div style="text-align:center;margin-top:10px">
            <pagination
              v-show="listCount>0"
              :total="listCount"
              :layout="'total, prev, pager, next, jumper'"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              @pagination="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <!-- 基地预览 -->
      <div class="baseimg">
        <div>
          <img
            src="../../../assets/train/u1525.png"
            alt
            style="width:30px;height:30px;vertical-align:middle;"
          />
          <span style="font-size:18px;font-weight:700;margin-left:8px;color:#333333">基地预览</span>
        </div>
        <div class="firstmetter">
          <el-carousel indicator-position="outside" :autoplay="false">
            <nodata v-if="photocom.length==0" style="margin-top: 100px;"></nodata>
            <el-carousel-item v-for=" (item,index) in photocom" :key="index" class="zoumadeng">
              <div v-for="(items,indexs) in item" :key="indexs">
                <img :src="items.aaaphoto" alt style="width:240px;height:200px" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 基础信息 -->
      <div class="basemessage">
        <basemessage :baseData="baseData"></basemessage>
      </div>
    </div>
    <!-- <linecom></linecom> -->
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
import * as trainapi from '@/api/train/index';
import vsmallheader from '@/views/smallHeader/index';
import basemessage from './basemessage/basemessage';
import linecom from '@/components/linecom/index';
export default {
  components: {
    vsmallheader,
    basemessage,
    linecom,
    Pagination,
  },
  data() {
    return {
      photocom: [],
      baseData: {},
      occupyMouth: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
      occupyMouthindex: 0,
      photo: [],
      listQuery: {
        page: 1,
        limit: 10,
        type: 0,
        id: 0,
      },
      listform: [],
      listCount: 0,
    };
  },
  created() {
    this.getlist();
    this.getIdbaselist();
    // console.log(this.baseData)
  },
  methods: {
    retrun() {
      this.$router.go(-1);
    },
    trainclass(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
        },
      });
    },
    mouthArea(index, item) {
      this.occupyMouthindex = index;
    },
    getlist() {
      this.listQuery.id = this.$route.query.id;
      trainapi.TrainBaseGetList(this.listQuery).then((res) => {
        res.data.forEach((element, index) => {
          res.data[index].startime = element.startime.slice(0, 10);
          res.data[index].endtime = element.endtime.slice(0, 10);
        });
        this.listform = res.data;
        this.listCount = res.count;
      });
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getlist();
    },
    getIdbaselist() {
      trainapi.GetTrainBase({ id: this.$route.query.id }).then((res) => {
        console.log(res);
        this.baseData = res.result;
        let a = [];
        if (this.baseData.imgList != '') {
          a = this.baseData.imgList.split(',');
        }
        a.forEach((element) => {
          let b = {
            aaaphoto: '',
          };
          b.aaaphoto = element;
          this.photo.push(b);
        });
        this.forphoto(this.photo);
      });
    },
    forphoto(list) {
      // list是要进行拆分的数组数组
      //    思路：将整组图片数据进行拆分，变成二维数组，一个数组里面放八个数据，多的放下一个数组
      const listResult = []; // 最终返回的二维数组
      for (let i = 0; i < Math.ceil(list.length / 4); i++) {
        listResult[i] = [];
        // 最终获得多少个二维数组
        for (let j = 0; j < 4; j++) {
          // 如果是最后一个板块
          if (i === Math.ceil(list.length / 4) - 1) {
            if (Math.ceil(list.length % 4) !== 0) {
              // 只有最后一个板块的数据在余数以内的才赋值
              if (j < Math.ceil(list.length % 4)) {
                listResult[i][j] = list[i * 4 + j];
              }
            } else {
              // 如果刚好整整一个板块，则全部附上值
              listResult[i][j] = list[i * 4 + j];
            }
          } else {
            listResult[i][j] = list[i * 4 + j];
          }
        }
      }
      // return listResult;
      this.photocom = listResult;
      // console.log(this.photocom)
    },
  },
};
</script>
<style scoped>
.baseBox {
  width: 1200px;
  /* height: 1000px; */
  margin: 0 auto;
}
.baseIntroduce {
  height: 450px;
  display: flex;
  margin-top: 5px;
}
.baseIntroduce > div:nth-child(1) {
  width: 570px;
  background-color: #fff;
  box-shadow: 2px 2px 5px 1px rgba(215, 215, 215, 35%);
}
.baseIntroduce > div:nth-child(2) {
  width: 600px;
  margin-left: 30px;
  background-color: #fff;
  box-shadow: 2px 2px 5px 1px rgba(215, 215, 215, 35%);
}
.baseIntroduceMetter {
  padding: 20px;
  text-indent: 35px;
  font-size: 18px;
  height: 364px;
  color: #555;
  overflow: hidden;
  /* text-overflow:ellipsis;
    white-space:nowrap; */
  overflow-x: hidden;
  overflow-y: scroll;
  overflow: auto;
}
.occupyMouth {
  display: flex;
}
.occupyMouth > div {
  text-align: center;
  height: 40px;
  flex: 1;
  line-height: 40px;
  border: solid 1px rgb(216, 215, 215);
  cursor: pointer;
}
.heightlight {
  background-color: #02a7f0 !important;
  /* border: 1px solid #4876C4; */
  color: #f8fafc !important;
}
.baseIntroduceoccupyMouth {
  height: 330px;
  padding: 10px 5px;
  overflow-x: hidden;
  overflow-y: scroll;
  overflow: auto;
}
.baseIntroduceoccupyMouth /deep/ .el-progress__text {
  color: rgba(233, 124, 0, 0.842);
  font-weight: 700;
}
.baseIntroduceoccupyMouth /deep/.el-progress-bar__inner {
  background: linear-gradient(
    to right,
    rgb(58, 143, 255),
    rgb(37, 211, 104)
  ) !important;
}
.baseIntroduceoccupyMouth /deep/.el-progress-bar__outer {
  height: 12px !important;
}
.baseimg {
  margin-top: 20px;
  height: 355px;
  background-color: #fff;
  box-shadow: 2px 2px 5px 1px rgba(215, 215, 215, 35%);
}
.baseimg > div:nth-child(1) {
  height: 50px;
  line-height: 50px;
  padding-left: 30px;
  border-bottom: solid 1px rgb(216, 213, 213);
}
.firstmetter {
  /* margin-top: 20px; */
  /* margin: 10px 10px; */
  width: 900;
  height: 320px;

  /* background-color: blue; */
}
.zoumadeng {
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.zoumadeng > div {
  /* flex:1 */
  width: 25%;
}
.zoumadeng > div > img {
  padding-top: 50px;
  display: block;
  margin: 0 auto;
}
.firstmetter /deep/.el-carousel__container {
  height: 260px;
}
.firstmetter /deep/.el-carousel__button {
  height: 15px;
  width: 15px;
  background-color: rgb(15, 91, 189) !important;
  border-radius: 50%;
}
.basemessage {
  /* height: 700px; */
  min-height: 400px;
  padding-bottom: 50px;
  box-shadow: 2px 2px 5px 1px rgba(215, 215, 215, 35%);
  margin-bottom: 20px;
}
.baseuseTitle:hover {
  cursor: pointer;
  color: #1492ff;
}
</style>